export function saveDataToSessionStorage(key: string, data: object): void {
  if (data === null || data === undefined) {
    return;
  }
  sessionStorage.setItem(key, JSON.stringify(data));
}

export function loadDataFromSessionStorage(key: string): object | null {
  const data = sessionStorage.getItem(key);
  return data ? JSON.parse(data) : null;
}

export function clearSessionStorage(key: string): void {
  sessionStorage.removeItem(key);
}